import {createReducer} from 'redux-create-reducer';
import {Keys, Actions} from '../constants';
import {standardLoadingReducerFactory} from './reducer-utils';

export default createReducer(
    {},
    standardLoadingReducerFactory(
        Actions.GET_WORK_SESSION_TEMPLATES,
        Keys.StoreSliceData.WORK_SESSION_TEMPLATES
    )
);



// WEBPACK FOOTER //
// ./src/model/reducers/work-session-template-reducer.js